import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		errorMessage: {
			color: theme.palette.error.main,
			fontSize: "0.75rem",
			fontWeight: "bold",
		},
		edit: {
			minWidth: 20,
			marginLeft: 2,
		},
		infoRoot: {
			paddingTop: 2,
			paddingBottom: 2,
		},
		infoMessage: {
			paddingTop: 4,
			paddingBottom: 4,
		},
		infoMessageIcon: {
			alignSelf: "center",
			paddingTop: 1,
			paddingBottom: 1,
		},
		buttonContainer: {
			marginTop: 8,
		},
	} satisfies Record<string, CSSObject>)
}
